var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ColorPalette", {
    attrs: {
      value: _vm.selectedColor,
      colorsGrid: _vm.getExtensionOptionColorsGrid(),
      tooltip: _vm.getExtensionOptionLabel(),
      icon: _vm.getExtensionOptionIcon(),
      active: _vm.active,
      disabled: _vm.disabled,
      isVisible: _vm.showColorPalette
    },
    on: {
      "update:visibility": _vm.updateVisibility,
      "update:value": _vm.updateHighlight,
      "reset:value": _vm.resetHighlight
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }